// removed by extract-text-webpack-plugin
module.exports = {"mainLayoutStyling":"mainLayoutStyling"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layouts/Layout.css
// module id = 601
// module chunks = 0